export default __webpack_public_path__ + "static/media/Say-Hello.a1fe72e0.png";